import { lazy } from "react";

/**
 * Quick submit where this build has it, and `undefined` where it does not.
 *
 * Named environments rather than "anything but production", so a production
 * build that lost its env file does not gain this by default.
 *
 * Read here rather than through `config`, deliberately: the condition and the
 * `import()` must stay in one module, because only there does a build settle the
 * condition before choosing chunks. Behind a flag imported from elsewhere the
 * chunk is still emitted — referenced by nothing, but deployed.
 */
export const QuickSubmit =
  import.meta.env.DEV ||
  import.meta.env.VITE_ENVIRONMENT === "dev" ||
  import.meta.env.VITE_ENVIRONMENT === "staging" ||
  import.meta.env.VITE_ENVIRONMENT === "docker"
    ? lazy(() => import("./QuickSubmit.js"))
    : undefined;
